/* eslint-disable */
import { Button } from '@/Components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'

const DateSwitcher = (props) => {
    const { currentDate, handleDateChange, isCurrentDate } = props;
    return (
        <div className='flex items-center gap-2 ml-2'>
            <Button
                variant='ghost'
                size='icon'
                onClick={() => handleDateChange('prev', currentDate?.type)}
            >
                <ChevronLeft className='h-4 w-4' />
            </Button>
            <span className='text-sm font-medium'>{currentDate?.text}</span>
            <Button
                variant='ghost'
                size='icon'
                onClick={() => handleDateChange('next', currentDate?.type)}
                disabled={isCurrentDate}
                className={isCurrentDate ? 'opacity-50 cursor-not-allowed' : ''}
            >
                <ChevronRight className='h-4 w-4' />
            </Button>
        </div>
    )
}

export default DateSwitcher;
